<mat-accordion #accordion="matAccordion" [multi]="true">

  <div class="pt-3" *ngIf="enterpriseConfigHsmAndBranch && enterpriseConfigHsmAndBranch.enableHsm === true">
    <mat-checkbox  color="primary" [disabled]="true" checked="true">
      <strong>{{'title.sign_hsm_config' | translate}}</strong>
    </mat-checkbox>
    <div class="d-flex">
      <em >{{'form.hsm_permission' | translate}}.</em>
    </div>
  </div>

  <div class="pt-3" *ngIf="enterpriseConfigHsmAndBranch && enterpriseConfigHsmAndBranch.enableManageBranch === true">
    <mat-checkbox color="primary" [disabled]="true" checked="true">
      <strong>{{'title.edit_config_branch' | translate}}</strong>
    </mat-checkbox>
    <div class="d-flex">
      <em >{{'form.branch_permission_enable' | translate}}.</em>
    </div>
  </div>

    <!-- Cấu hình đăng nhập xác thực 2 lớp  -->
    <div class="reminder-to-sign"> {{'config_enterprise.login_authen_mysign' |
      translate}}
      <mat-button-toggle-group class="toggle-button">
          <mat-button-toggle [checked]="enterpriseConfigHsmAndBranch.isTwoFactorAuthen" id="on-button"
              [value]="enterpriseConfigHsmAndBranch.isTwoFactorAuthen" (click)="clickSend(true)">
              {{'search_form.btn_config_notify_on' | translate}}
          </mat-button-toggle>
          <mat-button-toggle [checked]="!enterpriseConfigHsmAndBranch.isTwoFactorAuthen"
              [value]="!enterpriseConfigHsmAndBranch.isTwoFactorAuthen" (click)="clickSend(false)">
              {{'search_form.btn_config_notify_off' | translate}}
          </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <ng-container *ngIf="enterpriseConfigHsmAndBranch.isTwoFactorAuthen">
      <div class="reminder-to-sign">
          <span>{{'config_enterprise.means_send_notifications' | translate}} <span style="color: #EC0033;">&nbsp;*</span></span>
          <mat-checkbox class="mat-checkbox" color="primary" [checked]="enterpriseConfigHsmAndBranch.isTwoFactorAuthenInternal" (change)="onCheckboxInternalChange()">
            {{'config_enterprise.internal' | translate}}
          </mat-checkbox>
          <mat-checkbox class="mat-checkbox" color="primary" [checked]="enterpriseConfigHsmAndBranch.isTwoFactorAuthenExternal" (change)="onCheckboxExternalChange()">
            {{'config_enterprise.external' | translate}}
          </mat-checkbox>
      </div>
    </ng-container>
    <span *ngIf="enterpriseConfigHsmAndBranch.isTwoFactorAuthen && !enterpriseConfigHsmAndBranch.isTwoFactorAuthenInternal && !enterpriseConfigHsmAndBranch.isTwoFactorAuthenExternal" class="error-text">{{'config_enterprise.required_verify' | translate}}</span>
    <div class="dive"></div>
    <!-- Cấu hình IP được phép đăng nhập -->
    <div class="reminder-to-sign"> {{'config_enterprise.config_ip_login' |
      translate}}
      <mat-button-toggle-group class="toggle-button">
          <mat-button-toggle [checked]="enterpriseConfigHsmAndBranch.isIpAllowed" id="on-button-ip"
              [value]="enterpriseConfigHsmAndBranch.isIpAllowed" (click)="clickConfigIp(true)">
              {{'search_form.btn_config_notify_on' | translate}}
          </mat-button-toggle>
          <mat-button-toggle [checked]="!enterpriseConfigHsmAndBranch.isIpAllowed"
              [value]="!enterpriseConfigHsmAndBranch.isIpAllowed" (click)="clickConfigIp(false)">
              {{'search_form.btn_config_notify_off' | translate}}
          </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
    <ng-container *ngIf="enterpriseConfigHsmAndBranch.isIpAllowed">
      <div class="header-table">
        <span class="table-title">{{'config_enterprise.list_ip_address' | translate}} ({{enterpriseConfigHsmAndBranch.ipAlloweds.length}}) {{'config_enterprise.selected' | translate}} ({{dataSelected.size}})</span>
        <div class="buttonMD" style="display: flex;">
          <button class="btn1-mine " mat-stroked-button color="primary" type="button"
                  (click)="onAddLot()">
            <mat-icon class="mr-0">folder</mat-icon>
            {{'certificate_management.button.upload' | translate}}
          </button>
          <button class="btn1-mine" mat-stroked-button color="primary" type="button"
                  (click)="onConfigIp()">
            <mat-icon class="mr-0">add_circle</mat-icon>
            {{'button.add' | translate}}
          </button>
          <div class="button-more" color="primary" [matMenuTriggerFor]="menuFeature" *ngIf="dataSelected.size > 0">
            <mat-icon class="icon-more">more_vert</mat-icon>
          </div>
          <div class="button-more" color="primary" *ngIf="dataSelected.size === 0" style="cursor: default;">
            <mat-icon class="icon-more" style="color: #b5b4b4;">more_vert</mat-icon>
          </div>
        </div>
      </div>
       <!-- menu button -->
      <mat-menu #menuFeature="matMenu" >
        <button class="btn1-mine"
                [disabled]="this.dataSelected.size === 0 || this.enterpriseConfigHsmAndBranch.ipAlloweds === null
                || this.enterpriseConfigHsmAndBranch.ipAlloweds.length === 0" mat-menu-item 
                [ngClass]="{'enable-button': !(this.dataSelected.size === 0 || this.enterpriseConfigHsmAndBranch.ipAlloweds === null
                || this.enterpriseConfigHsmAndBranch.ipAlloweds.length === 0) }" (click)="openMenuDelete()"
                style="text-align: center; 
                height: 30px;
                display: flex;
                flex-direction: row;
                justify-content: center;
                align-items: center;"
        >
          {{'button.delete' | translate}}
        </button>
      </mat-menu>  
      <div class="table-user">
        <mat-table [dataSource]="listData" class="mat-table-col-extra-sm" style="min-width: 1000px; width: 100%; border-top: 1px solid #c8c8c8;">
        <!-- check -->
        <ng-container matColumnDef="check" >
          <mat-header-cell *matHeaderCellDef
                            class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom">
            <mat-checkbox
              [(ngModel)]="checkAll" (change)="checkAllCheckBox()" color="primary"></mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let element"
                    class="mat-header-cell-center check-col mat-cell-non-boder-right-bottom "
                    (click)="$event.stopPropagation()"
                  >
            <mat-checkbox color="primary" [(ngModel)]="element.checked"
                          (change)="onSelect(element)">
            </mat-checkbox>
          </mat-cell>
        </ng-container>
        <!-- STT -->
        <ng-container matColumnDef="STT">
          <mat-header-cell *matHeaderCellDef class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom">
            {{'enterprise_contract.table_headers.No' | translate}}
          </mat-header-cell>
            <mat-cell *matCellDef="let element; let i = index" class="mat-header-cell-center no-col mat-cell-non-boder-right-bottom"
              (click)="$event.stopPropagation()"
            
            >
            {{element.order ? element.order : i + 1}}
            </mat-cell>
        </ng-container>

        <ng-container matColumnDef="ip">
          <mat-header-cell *matHeaderCellDef 
                            class="mat-header-cell-center mat-cell-non-boder-right-bottom" >
            {{'config_enterprise.address' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" matTooltip="{{ element.ip}}"
                    class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                    
                    >
            <span class="fix-width">{{ element.ip }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="description">
          <mat-header-cell *matHeaderCellDef 
                            class="mat-header-cell-center mat-cell-non-boder-right-bottom"  >
            {{'config_enterprise.note' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" matTooltip="{{element.description}}"
                    class="mat-cell-non-boder-right-bottom" (click)="$event.stopPropagation()"
                    
                    >
            <span class="fix-width">{{ element.description }}</span>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="action">
          <mat-header-cell *matHeaderCellDef class="mat-header-cell-center" style="min-width: 150px; max-width: 150px;">
            {{'headertable.action' | translate}}
          </mat-header-cell>
          <mat-cell *matCellDef="let element" (click)="$event.stopPropagation()"
                    class="number-cell-center"
                    style="min-width: 150px; max-width: 150px;"
          >
            <button
              mat-icon-button (click)="onUpdate(element)"
              style="margin-right: 16px;"
            >
              <mat-icon matTooltip="{{'enterprise_contract.buttons.edit' | translate}}">
                edit
              </mat-icon>
            </button>

            <!-- <a nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                  'config_enterprise.confirm_delete_ip' | translate
                  }}" (nzOnConfirm)="onClickDeleteElement(element)"
                  nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                  <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
            </a> -->
            <a (click)="onClickDeleteElement(element)">
              <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
            </a>
          </mat-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="columnDefinitions; sticky: true"></mat-header-row>
        <mat-row *matRowDef="let row; columns: columnDefinitions;" matRipple class="element-row" [cdkDetailRow]="row"
        >
        </mat-row>
        </mat-table>
      </div>
      <mat-divider class="mt-2"></mat-divider>
      <app-pagination class="my-3" [(paginate)]="paginate" (pageChange)="onFilterData($event.page, $event.pageSize)">
      </app-pagination>
    </ng-container>

    <!-- Cấu hình log doanh nghiệp tác động  -->
    <div class="reminder-to-sign"> {{'config_enterprise.enterprise_action_log' |
      translate}}
      <mat-button-toggle-group class="toggle-button">
          <mat-button-toggle [checked]="enterpriseConfigHsmAndBranch.isEnterpriseActionLog" id="on-button"
              [value]="enterpriseConfigHsmAndBranch.isEnterpriseActionLog" (click)="clickEnterpriseActionLog(true)">
              {{'search_form.btn_config_notify_on' | translate}}
          </mat-button-toggle>
          <mat-button-toggle [checked]="!enterpriseConfigHsmAndBranch.isEnterpriseActionLog"
              [value]="!enterpriseConfigHsmAndBranch.isEnterpriseActionLog" (click)="clickEnterpriseActionLog(false)">
              {{'search_form.btn_config_notify_off' | translate}}
          </mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <!-- Cấu hình sử dụng tên rút gọn -->
  <div class="reminder-to-sign">
    {{'config_enterprise.short_name_enterprise' | translate}}

  <mat-button-toggle-group class="toggle-button">
    <mat-button-toggle
      [checked]="enterpriseConfigHsmAndBranch.isShortName"
      id="on-button-short"
      [value]="enterpriseConfigHsmAndBranch.isShortName"
      (click)="clickUseShortName(true)">
      {{'search_form.btn_config_notify_on' | translate}}
    </mat-button-toggle>

    <mat-button-toggle
      [checked]="!enterpriseConfigHsmAndBranch.isShortName"
      id="on-button-short"
      [value]="!enterpriseConfigHsmAndBranch.isShortName"
      (click)="clickUseShortName(false)">
      {{'search_form.btn_config_notify_off' | translate}}
    </mat-button-toggle>
  </mat-button-toggle-group>
</div>
      <!-- Chỉ hiện ô nhập khi bật toggle -->
      <div class="col-md-5" *ngIf="enterpriseConfigHsmAndBranch.isShortName" style="display: flex;">
        <label style="display: flex; align-items: center; min-width: 150px; font-weight: bold;">
          {{'config_enterprise.short_name' | translate}}
          <span class="required">&nbsp;*</span>
        </label>
        <mat-form-field class="w-100" style="width: 70% !important">
          <input
            style="height: 20px;"
            matInput
            autocomplete="off"
            type="text"
            name="shortName"
            [placeholder]="'config_enterprise.short_name' | translate"
            [(ngModel)]="enterpriseConfigHsmAndBranch.shortName"
            #shortNameInput="ngModel"
            (blur)="trimValue()"
            (ngModelChange)="isFormChanging = true"
            maxlength="50"
            [ngClass]="{ 'is-invalid': shortNameInput.touched && shortNameInput.invalid }" />
      
          <button
            mat-button
            *ngIf="enterpriseConfigHsmAndBranch.shortName"
            type="button"
            matSuffix
            mat-icon-button
            aria-label="Clear"
            (click)="enterpriseConfigHsmAndBranch.shortName = ''; isFormChanging = true">
            <mat-icon>close</mat-icon>
          </button>
      
          <mat-error *ngIf="shortNameInput.touched && shortNameInput.invalid">
            {{ 'config_enterprise.short_name_request' | translate }}
          </mat-error>
        </mat-form-field>
      </div>
    <div class="dive"></div>

    <!-- Huỷ bỏ & Lưu  -->
    <mat-card-actions class="text-center mt-3">
      <button mat-stroked-button color="primary" class="mr-3" (click)="onNoClick()" type="button">
        <mat-icon class="mr-0">cancel</mat-icon>
        {{'button.cancel' | translate}}
      </button>
      <button mat-raised-button
        (click)="onSave()"
        color="primary"
        [disabled]="!checkDisableSave()"
        >
        <mat-icon class="mr-0">save</mat-icon>
        {{'config_notification.save_config' | translate}}
      </button>
    </mat-card-actions>
  


</mat-accordion>
